import Vue from 'vue'

module.exports = {

    token: null,

    intercept: function(request, next) {
        if (typeof request.headers.map.disableInterceptor !== "undefined") {
            delete request.headers.map.disableInterceptor;
        } else {
            request.headers.set('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
            request.headers.set('Cache-Control', 'no-cache');
            request.headers.set('Pragma', 'no-cache');
        }

        next();
    }

};